import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { contactPage } from '../data/contact';
import { InquiryForm } from '../components/InquiryForm';
import { ServiceAreaSection } from '../components/ServiceAreaSection';
export function ContactPage() {
  const {
    office
  } = contactPage;
  return <>
      <section id="top" aria-labelledby="contact-page-title" className="bg-ivory pb-14 pt-10 md:pb-20 md:pt-14 lg:pb-24 lg:pt-16" data-id="element-558" data-mp="xo15orwdsjfq">
        <div className="site-container grid gap-8 lg:grid-cols-12 lg:gap-x-14 lg:gap-y-10" data-id="element-559" data-mp="116bgnnetx1j">
          {/* Heading — first on every viewport */}
          <div className="lg:col-span-5 lg:row-start-1" data-id="element-560" data-mp="9zi8p8is7t2y">
            <p className="eyebrow text-moss" data-id="element-561" data-mp="a24fv71rg6kn">{contactPage.eyebrow}</p>
            <h1 id="contact-page-title" className="mt-5 font-display text-[38px] font-medium leading-[1.05] tracking-[-0.01em] text-charcoal sm:text-[50px] lg:text-[58px]" data-id="element-562" data-mp="f0fpbgo58f2c">
              {contactPage.title}
            </h1>
          </div>

          {/* Single inquiry form — second on phones, right column on desktop */}
          <div id="contact" className="bg-olive p-2 sm:p-3 lg:col-span-7 lg:col-start-6 lg:row-span-3 lg:row-start-1 lg:self-start" data-id="element-563" data-mp="myjwqblqdgnb">
            <InquiryForm headingLevel="h2" messageHelper={contactPage.messageHelper} data-id="element-564" data-mp="hyfccahpc1rt" />
          </div>

          {/* Introduction and service paths */}
          <div className="lg:col-span-5 lg:row-start-2" data-id="element-565" data-mp="81kg5y8widgp">
            <p className="max-w-[520px] text-[16px] leading-relaxed text-charcoal/75 sm:text-[17px]" data-id="element-566" data-mp="833v9litmigw">{contactPage.intro}</p>
            <ul aria-label="Our services" className="mt-6 border-t border-charcoal/15" data-id="element-567" data-mp="399eapulohli">
              {contactPage.services.map(service => <li key={service.href} className="border-b border-charcoal/15" data-id="element-568" data-mp="3qguygjfd5iog">
                  <a href={service.href} className="focus-ring group flex min-h-[48px] items-center justify-between gap-4 py-3 text-[15.5px] text-charcoal transition-colors duration-150 hover:text-olive" data-id="element-569" data-mp="3lh8m0c7d06gp">
                    <span data-id="element-570" data-mp="36wcym56hp5pp">{service.label}</span>
                    <ArrowRightIcon className="h-4 w-4 shrink-0 text-moss transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-571" data-mp="3bu4o6sjnwfqq" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Office details */}
          <div className="bg-stone/70 p-6 sm:p-8 lg:col-span-5 lg:row-start-3" data-id="element-572" data-mp="3ujujrhv915jp">
            <h2 className="font-display text-[24px] font-medium leading-tight text-charcoal sm:text-[26px]" data-id="element-573" data-mp="3gsfvowmhie5s">{office.heading}</h2>
            <dl className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-574" data-mp="3ksq56j9hjmpe">
              <div data-id="element-575" data-mp="cdzlsu32l9wp">
                <dt className="eyebrow text-moss" data-id="element-576" data-mp="cdpwl8pun6s2">Office</dt>
                <dd className="mt-2 text-[15.5px] leading-relaxed text-charcoal" data-id="element-577" data-mp="cc52fk7g5puq">
                  {office.street}
                  <br data-id="element-578" data-mp="21utusy6a4vw1" />
                  {office.city}
                </dd>
              </div>
              <div data-id="element-579" data-mp="1ww0eyz3isssp">
                <dt className="eyebrow text-moss" data-id="element-580" data-mp="1wwjvqchfpb55">Phone</dt>
                <dd className="mt-2" data-id="element-581" data-mp="1wu65cgxp8n3x">
                  <a href={office.phoneHref} className="focus-ring inline-flex min-h-[44px] items-center gap-2 text-[15.5px] font-medium text-olive underline decoration-olive/30 underline-offset-4 hover:decoration-olive" data-id="element-582" data-mp="2bl6c8hiss8xy">
                    <PhoneIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-583" data-mp="1dxecbfscutmo" />
                    {office.phoneDisplay}
                  </a>
                </dd>
              </div>
              <div data-id="element-584" data-mp="1nvc1c5i1gugc">
                <dt className="eyebrow text-moss" data-id="element-585" data-mp="1nusqt9upx8cc">Office hours</dt>
                <dd className="mt-2 text-[15.5px] leading-relaxed text-charcoal" data-id="element-586" data-mp="1nxorh5xyab4h">{office.hours}</dd>
              </div>
              <div data-id="element-587" data-mp="2zar6hwkeismj">
                <dt className="eyebrow text-moss" data-id="element-588" data-mp="2zbaikwndemsn">Weekend hours</dt>
                <dd className="mt-2 text-[15.5px] leading-relaxed text-charcoal" data-id="element-589" data-mp="18tdmlmgyzuol">{office.weekend}</dd>
              </div>
            </dl>
          </div>
        </div>
      </section>

      <ServiceAreaSection showAction={false} data-id="element-590" data-mp="1dukurmn0yvvs" />
    </>;
}